var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiHeaderClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 9.71094L12.7734 12.5234L15.5625 15.3125C15.7969 15.5234 15.7969 15.875 15.5625 16.0859C15.3516 16.3203 15 16.3203 14.7891 16.0859L11.9766 13.2969L9.1875 16.0859C8.97656 16.3203 8.625 16.3203 8.41406 16.0859C8.17969 15.875 8.17969 15.5234 8.41406 15.2891L11.2031 12.5L8.41406 9.71094C8.17969 9.5 8.17969 9.14844 8.41406 8.91406C8.625 8.70312 8.97656 8.70312 9.21094 8.91406L12 11.7266L14.7891 8.9375C15 8.70312 15.3516 8.70312 15.5859 8.9375C15.7969 9.14844 15.7969 9.5 15.5859 9.71094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiHeaderClose);
export default __webpack_public_path__ + "static/media/ai-header-close.383db4ccf790a06fe59aba8ffa89e625.svg";
export { ForwardRef as ReactComponent };